import React, { useEffect, useState } from "react";

const VisitCounter = () => {
  const [visits, setVisits] = useState(0);

  useEffect(() => {
    // Get the stored visit count or set to 0 if not found
    let visitCount = localStorage.getItem("visitCount");
    if (!visitCount) {
      visitCount = 0;
    } else {
      visitCount = parseInt(visitCount);
    }

    // Increment and store the new count
    const newCount = visitCount + 1;
    localStorage.setItem("visitCount", newCount);
    setVisits(5000 + newCount);
  }, []);

  return (
    <div style={styles.counterContainer}>
      <h2 style={styles.heading}>Total Visitors</h2>
      <div style={styles.counter}>{visits}</div>
    </div>
  );
};

// CSS Styles
const styles = {
  counterContainer: {
    textAlign: "center",
    padding: "10px",
    // background: "#2c3e50",
    background : "#6B21A8",
    color: "#fff",
    borderRadius: "10px",
    width: "80px",
    margin: "20px auto",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  },
  heading: {
    marginBottom: "2px",
    fontSize: "10px",
  },
  counter: {
    fontSize: "20px",
    fontWeight: "semibold",
    // background: "#e74c3c",
    // padding: "2px",
    borderRadius: "5px",
    display: "inline-block",
  },
};

export default VisitCounter;
